import React from 'react'
import PropTypes from 'prop-types'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'

function OverviewRisk({ fund, renderRiskLayout24 }) {
  const risk = assignRisk(fund, renderRiskLayout24)

  return (
    <div className="Content u-paddingVert0" id="risk">
      <h3 className="u-marginTop0">Risk</h3>
      <ul className="u-marginBottom0 u-marginLeft0">
        {risk.mStarRiskCtg && renderMorningStarRisk(risk)}
        {risk && !renderRiskLayout24 && renderFundRisk(risk)}
      </ul>
      {risk.showMoreButton && (
        <a className="Link u-textSecondary" href="#ratings-risk">
          View more
        </a>
      )}
    </div>
  )
}

function assignRisk(fund, renderRiskLayout24) {
  const riskMStar24 = {
    mStarRiskCtg: fund.mStarRiskVsCtg,
    mStarRiskAsOfDt: fund.mStarRatingAsOfDt,
    showMoreButton: false,
  }

  const risk = renderRiskLayout24 ? riskMStar24 : fund.riskDetail || {}
  if (!renderRiskLayout24) {
    risk.showMoreButton = true
  }

  return risk
}

function renderMorningStarRisk({ mStarRiskCtg, mStarRiskAsOfDt }) {
  return (
    <li className="u-marginBottom3gu u-decoUnbulleted u-marginHoriz0">
      <h4 className="u-marginBottom1gu">Morningstar Overall Risk</h4>
      <ul className="Grid u-sizeFull u-marginLeft0 Risk-gauge">
        {compareRiskGaugeWithMStarRisk(mStarRiskCtg)}
      </ul>
      <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
        as of {formatDateStandard(mStarRiskAsOfDt)}
      </p>
    </li>
  )
}

function compareRiskGaugeWithMStarRisk(mStarRisk) {
  const riskGauge = ['Low', 'Below Avg.', 'Average', 'Above Avg.', 'High']

  return riskGauge.map((risk) => {
    if (mStarRisk.toLowerCase() === risk.toLowerCase()) {
      return (
        <li
          className="u-inlineBlock u-flexAuto u-decoUnbulleted u-textCenter u-textUppercase u-textTight u-textReversed u-flexAlignSelfCenter u-bgColorBrandLight"
          key={risk}
          value={risk}
        >
          {risk}
        </li>
      )
    } else {
      return (
        <li
          className="u-inlineBlock u-size1of12 u-paddingHoriz4gu u-decoUnbulleted"
          key={risk}
        ></li>
      )
    }
  })
}

function renderFundRisk({ riskLabels, risks, riskEffectiveDate }) {
  const result = []

  riskLabels &&
    riskLabels.map((risk) => {
      result.push(compareRiskWithDetail(risk, risks))
    })

  return result.map((risk) => {
    return (
      <li
        className="u-marginBottom3gu u-decoUnbulleted u-marginHoriz0"
        key={risk.value}
      >
        <h4>{risk.description}</h4>
        <p className="u-textSizeMsrp3 u-textSolid u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
          {risk.value}%
        </p>
        <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
          {' '}
          as of {formatDateStandard(riskEffectiveDate)}
        </p>
      </li>
    )
  })
}

function compareRiskWithDetail(risk, riskDetails) {
  const matchingdDetail = {}

  riskDetails.map((detail) => {
    if (risk === detail.description) {
      matchingdDetail.description = detail.description
      matchingdDetail.value = detail.value
    }
  })

  return matchingdDetail
}

OverviewRisk.propTypes = {
  fund: PropTypes.object,
  renderRiskLayout24: PropTypes.bool,
}

renderMorningStarRisk.propTypes = {
  mStarRiskCtg: PropTypes.string,
  mStarRiskAsOfDt: PropTypes.string,
}
export default OverviewRisk
